import React from "react";

import Header from "../../components/header";
import CardInfoOption from "../../components/Health/components/cards/CardInfoOption";

import { ContainerInfo, TextNumbers } from "../../components/Health/components/cards/CardInfoOption/styles";
import {
  Back,
  ContainerImage,
  ContainerMain,
  Description,
  Image,
  Title,
} from "../../styles/PageStyles/Health/stylesOptionsHealth";
import { useNavigate } from "react-router-dom";
import { RoutesNames } from "../../components/utils/routes";

const OptionsLegalAndDocumental = () => {
  const navigate = useNavigate();

  const handleForm = (redirect) => {
    navigate(redirect);
  };
  return (
    <div>
      <Header />
      <ContainerMain>
        <Back onClick={() => handleForm(RoutesNames.home)}>Volver</Back>
        <Title>Legal y Documental</Title>
        <Description>
          By accessing and placing an order with UXTheme, you confirm that you are in agreement with and bound by the
          terms and conditions
        </Description>
        <ContainerImage>
          <Image src="/Health/imageHealth.png" />
        </ContainerImage>
        <CardInfoOption number="1" press={() => handleForm(RoutesNames.rumv)} custom>
          <ContainerInfo one>
            <TextNumbers style={{ textAlign: "center", width: "72%" }}>
              Registro Único de Migrantes Venezolanos (RUMV)
            </TextNumbers>
            <TextNumbers>Recuerda:</TextNumbers>
            <TextNumbers>Debes tener tu documento de identidad a la mano.</TextNumbers>
          </ContainerInfo>
        </CardInfoOption>
        <CardInfoOption
          number="2"
          firstColor="#FFA13B"
          secondColor="#E8811A"
          press={() => handleForm(RoutesNames.biometric)}
          custom
        >
          <ContainerInfo one>
            <TextNumbers style={{ textAlign: "center", width: "72%" }}>Registro Biométrico</TextNumbers>
            <TextNumbers>Recuerda:</TextNumbers>
            <TextNumbers>
              Para este trámite debiste haber finalizado el paso # 1 o haber realizado previamente el registro RUMV.
            </TextNumbers>
          </ContainerInfo>
        </CardInfoOption>
        <CardInfoOption number="3" press={() => handleForm(RoutesNames.documents)} custom>
          <ContainerInfo one>
            <TextNumbers style={{ textAlign: "center", width: "72%" }}>Entrega de documentos</TextNumbers>
            <TextNumbers>Recuerda:</TextNumbers>
            <TextNumbers>
              para este trámite debiste haber realizado previamente el registro RUMV y el registro BIOMÉTRICO.
            </TextNumbers>
          </ContainerInfo>
        </CardInfoOption>
      </ContainerMain>
    </div>
  );
};

export default OptionsLegalAndDocumental;
